import FingerprintJS from '@fingerprintjs/fingerprintjs';

export async function getDeviceFingerprint() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();

  return result.visitorId;
}

export function getBrowserName() {
  const ua = navigator.userAgent;

  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('OPR') || ua.includes('Opera')) return 'Opera';

  return 'Unknown';
}

export function getDeviceName() {
  const ua = navigator.userAgent;

  const browser = getBrowserName();
  let os = 'Unknown OS';

  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac')) os = 'MacOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Android')) os = 'Android';

  return `${browser} on ${os}`;
}

export const handleMfaRedirect = (data, router, payload = {}) => {
  if (!data  || !data.mfaRequirement) return false;

  const mfaRequirement = data.mfaRequirement;

  if (!mfaRequirement.mfaRequired) return false;

  const { sessionToken, mfaMethod } = mfaRequirement;

  sessionStorage.setItem(
    'mfaSession',
    JSON.stringify({ sessionToken, mfaMethod, mfaResumePayload:payload })
  );

  router.push('/mfa');
  return true;
};